const API_URL = '/waste-evidence-header'

export const state = () => ({
  waste_evidence_headers: [],
  dashboard_data: null,
  waste_collection_logs: [],
  waste_collection_routes: [],
  route_id_filter: null,
})

export const getters = {
  getAll: state => {
    return state.waste_evidence_headers
  },
  get: state => waste_evidence_header_id => {
    return state.waste_evidence_headers.find(
      waste_evidence_header => waste_evidence_header.id === parseInt(waste_evidence_header_id)
    )
  },
  getRouteIdFilter: state => {
    return state.route_id_filter
  },
}

export const mutations = {
  SET_WASTE_EVIDENCE_HEADERS(state, waste_evidence_headers) {
    state.waste_evidence_headers = waste_evidence_headers
  },
  PUSH_OR_REPLACE_WASTE_EVIDENCE_HEADER(state, new_waste_evidence_header) {
    if (!new_waste_evidence_header || !new_waste_evidence_header?.id) {
      return
    }

    let waste_evidence_header_index = state.waste_evidence_headers.findIndex(
      waste_evidence_header => waste_evidence_header.id === parseInt(new_waste_evidence_header.id)
    )

    if (waste_evidence_header_index >= 0) {
      state.waste_evidence_headers.splice(waste_evidence_header_index, 1, new_waste_evidence_header)
    } else {
      state.waste_evidence_headers.push(new_waste_evidence_header)
    }
  },
  REMOVE_WASTE_EVIDENCE_HEADER(state, waste_evidence_header_id) {
    let waste_evidence_header_index = state.waste_evidence_headers.findIndex(
      waste_evidence_header => waste_evidence_header.id === parseInt(waste_evidence_header_id)
    )

    state.waste_evidence_headers.splice(waste_evidence_header_index, 1)
  },
  SET_WASTE_EVIDENCE_HEADER_SET_CUSTOMER(state, { waste_evidence_header_id, waste_customer_name }) {
    let waste_evidence_header_index = state.waste_evidence_headers.findIndex(
      waste_evidence_header => waste_evidence_header.id === parseInt(waste_evidence_header_id)
    )

    if (waste_evidence_header_index >= 0) {
      state.waste_evidence_headers[waste_evidence_header_index].customer = waste_customer_name
    }
  },
  SET_WASTE_EVIDENCE_HEADER_DASHBOARD_DATA(state, dashboardData) {
    state.dashboard_data = dashboardData
  },
  SET_WASTE_COLLECTION_LOGS(state, logs) {
    state.waste_collection_logs = logs
  },
  SET_WASTE_COLLECTION_ROUTES(state, routes) {
    state.waste_collection_routes = routes
  },
  SET_ROUTE_ID_FILTER(state, id) {
    state.route_id_filter = id
  },
}

export const actions = {
  async fetch({ commit }, waste_evidence_header_id) {
    let { data: waste_evidence_header, error } = await useApi(API_URL + '/' + waste_evidence_header_id)

    // return empty data
    if (error.value) {
      throw error.value
    }

    commit('PUSH_OR_REPLACE_WASTE_EVIDENCE_HEADER', waste_evidence_header.value)

    return waste_evidence_header.value
  },
  async update({ commit }, { waste_evidence_header, waste_evidence_header_id }) {
    let { data, error } = await useApi(API_URL + '/' + waste_evidence_header_id, {
      method: 'put',
      body: waste_evidence_header,
    })
    // return empty data
    if (error.value) {
      throw error.value
    }

    commit('PUSH_OR_REPLACE_WASTE_EVIDENCE_HEADER', waste_evidence_header)

    return waste_evidence_header
  },
  async delete({ commit }, waste_evidence_header_id) {
    await useApi(API_URL + '/' + waste_evidence_header_id, { method: 'delete' })

    commit('REMOVE_WASTE_EVIDENCE_HEADER', waste_evidence_header_id)
  },
  async setWasteCustomer({ commit }, { waste_evidence_header_id, waste_customer_id, waste_customer_name }) {
    await useApi(`${API_URL}/${waste_evidence_header_id}/waste-customer/${waste_customer_id}`, { method: 'patch' })

    commit('SET_WASTE_EVIDENCE_HEADER_SET_CUSTOMER', {
      waste_evidence_header_id,
      waste_customer_name,
    })
  },
  async findByBarcode({ commit }, barcode) {
    let { data } = await useApi(API_URL + '/find-by-barcode', {
      params: { barcode: barcode },
    })

    return data.value
  },
  async fetchDashboardData({ commit }, waste_evidence_header_id) {
    let { data: dashboardData } = await useApi(`${API_URL}/${waste_evidence_header_id}/dashboard`)

    commit('SET_WASTE_EVIDENCE_HEADER_DASHBOARD_DATA', dashboardData.value)

    return dashboardData.value
  },
  async fetchWasteCollectionLogs({ commit }, { waste_evidence_header_id, params }) {
    let { data: wasteCollectionLogs } = await useApi(`${API_URL}/${waste_evidence_header_id}/waste-collection`, {
      query: params,
    })

    commit('SET_WASTE_COLLECTION_LOGS', wasteCollectionLogs.value)

    return wasteCollectionLogs.value
  },
  async fetchWasteCollectionRoutes({ commit }, { waste_evidence_header_id, params }) {
    let { data: wasteCollectionRoutes } = await useApi(
      `${API_URL}/${waste_evidence_header_id}/waste-collection-route`,
      {
        query: params,
      }
    )

    commit('SET_WASTE_COLLECTION_ROUTES', wasteCollectionRoutes.value)

    return wasteCollectionRoutes.value
  },
  async addBinToWasteCollectionRoute({ commit }, { waste_collection_route_id, waste_evidence_header_id }) {
    await useApi(`${API_URL}/${waste_evidence_header_id}/waste-collection-route/${waste_collection_route_id}`, {
      method: 'patch',
    })
  },
  setRouteIdFilter({ commit }, id) {
    commit('SET_ROUTE_ID_FILTER', id)
  },
}
